import React, { useEffect, useState } from "react";
import { getCommunityDevelopmentList, CommunityItem } from "../Service/CommunityDevelopLink";
import { getCommunityPageContent, CommunityPageContent } from "../Service/CommunityDevelopLink";
import { Link, useLocation } from "react-router-dom";
import TypedText from "components/Homes/typewrite";
import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import Breadcrumb from "components/Breadcrumb";
import { API_BASE_CMS } from "helper/environment";
import Pagination from "@mui/material/Pagination";
const CommunityDevelopList: React.FC = () => {
 const [data, setdata] = useState<any | null>(null);
  // Fetch community items for carousel
  const [items, setItems] = useState<CommunityItem[]>([]);

const location = useLocation();
  useEffect(() => {
     const fetchData = async () => {
       const data = await getCommunityDevelopmentList();
 
       const filtered = (data || [])
         .filter(
           (item: any) =>
             item.status === true)
         .sort((a: any, b: any) => b.id - a.id); // DESC order
 
       setItems(filtered);
     };
     const fetchBanner = async () => {
         try {
           const bannerRes = await fetch(
             `${API_BASE_CMS}/jsonapi/node/community_development_page?include=field_image,field_image.field_media_image`
           );
             const bannerJson = await bannerRes.json();
                
                    const node = bannerJson.data[0]; // single object
                  
                    setdata(node);
   
         } catch (err) {
           console.error("Community banner fetch failed", err);
         }
       };
   
       fetchBanner();
     fetchData();
   }, []);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);  
const [currentPage, setCurrentPage] = useState(1);

const itemsPerPage = 6;
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentItems = items?.slice(indexOfFirstItem, indexOfLastItem);

const totalPages = Math.ceil((items?.length || 0) / itemsPerPage);
  const handleChange = (event:any, value:any) => {
    setCurrentPage(value);
  };

  if(!items) return null; 
   if(!data) return null; 
  // console.log(items)
 
  localStorage.setItem("cmbutton", data?.attributes?.field_media_back_button);
  return (
    <div id="section-communitylist">
      <div className="container py-2">
            <nav aria-label="breadcrumb animated slideInDown ">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a className="text-dark" href="/">Home</a></li>
                   
                    <li className="breadcrumb-item"><a className="text-dark" href="community-development">Community Development</a>
                    </li>
                </ol>
            </nav>
        </div>
      <div id="section" className="media">
        <div className="container">
          <div
            className="section-title  text-center mx-auto mb-5 wow fadeInUp clearfix"
            data-wow-delay="0.1s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}
          >
            <h6 className=" ">{data?.attributes?.field_small_title || ""}</h6>
             
                    <h2 className="mb-4 "> 
                      {data?.attributes?.field_main_title ?? 'Building'} <span className="text-primary">{data?.attributes?.field_title ?? 'Long-Term Social Value'}</span>
</h2>                      
 {/* <TypedText
                                index={1}
                                text={`<span style="color:#000">${data?.attributes?.field_main_title ?? 'Building Strong Communities with'}</span><br /> <span style="color:#2aa488">${data?.attributes?.field_title ?? 'Long-Term Social Value'}</span> `}
                                delay={100}
                                cursor="|" />  */}
                                 
                    <div className="mx-auto" dangerouslySetInnerHTML={{  __html: data?.attributes?.field_description_data?.value || "" }} />
                       
          </div>

          <div className="row g-4 ">
              {currentItems && currentItems?.map((s:any,i:any) => (
            <div
              className="col-md-6 col-sm-12 col-lg-4 mb-4 wow fadeInUp devel-card"
              data-wow-delay={`0.${i + 1}s`} key={i}
            >
             
                 <Link to={`${location.pathname}${s.path}`} className="text-dark text-decoration-none">
                <div className="service-item rounded-3 shadow-none overflow-hidden">
                  <div className="service-image rounded-3">
                    <img
                     className="img-fluid rounded-3"
                        src={s?.images?.url || ""}
                        alt={s?.images?.alt || ""}
                      loading="lazy"
                    />
                  </div>
                  <div className="position-relative  mt-3   pt-0">
                     <h6
                         className={`mb-2 text-dark ${!isMobile ? "titlemove" : ""}`}
                       >{s?.title || ""}</h6>
                      <div className={`mb-3 mb-md-3 mb-lg-3 para ${!isMobile ? "descriptionmove" : ""}`}
                        dangerouslySetInnerHTML={{
                          __html: s?.short_description || "",
                        }}
                      />

                      <span
                        className="btn btn-sm btn-primary rounded-pill text-center text-md-start text-lg-start"
                     
                      >
                        {s?.buttonText || ""}
                      </span>
                  </div>
                </div>
            </Link>
            </div>
              ))}

              <div className="col-sm-12">
                <div className="d-flex justify-content-center mt-2">
                   <Pagination
                                                           count={totalPages}
                                                           page={currentPage}
                                                           onChange={handleChange}
                                                           color="secondary"
                                                           className={totalPages <= 1 ? 'd-none' : ''}
                                                       />
                  <nav className="d-none">
                    <ul className="pagination">

                      {/* Previous */}
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>

                      {/* Page Numbers */}
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          key={index}
                          className={`page-item  ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>

                    </ul>
                  </nav>
                </div>
                
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityDevelopList;
